export default [
  {
    path: "/autopark/transports",
    name: "transports",
    component: () => import("@/modules/autopark/pages/transport/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Транспортные средства",
      permissions: ["transport:index"],
    },
  },
  {
    path: "/autopark/transport/:id",
    name: "transport",
    component: () => import("@/modules/autopark/pages/transport/open.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Транспортное средство",
      permissions: ["transport:show"],
    },
  },
  {
    path: "/autopark/transport/history",
    name: "transport-history",
    component: () => import("@/modules/autopark/pages/transport/history.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "История эксплуатации",
      permissions: ["transport:index"],
    },
  },
  {
    path: "/drivers",
    name: "drivers",
    component: () => import("./pages/drivers/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Водители",
      permissions: ["driver:index"],
    },
  },
  {
    path: "/driver/:id",
    name: "driver",
    component: () => import("./pages/drivers/open.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Водитель",
      permissions: ["driver:show"],
    },
  },
];
